import React from 'react';
import { useTeamTab } from '../TeamTabContext';

export const RemoveOrgMemberConfirm: React.FC = () => {
  const {
    orgMemberRemoveTarget,
    setOrgMemberRemoveTarget,
    orgMemberRemoveLoading,
    executeRemoveOrgMember,
    currentOrg,
  } = useTeamTab();

  if (!orgMemberRemoveTarget) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="org-member-remove-title"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10004,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.45)',
        padding: 16,
      }}
      onClick={() => !orgMemberRemoveLoading && setOrgMemberRemoveTarget(null)}
    >
      <div
        style={{
          maxWidth: 440,
          width: '100%',
          padding: '20px 22px',
          borderRadius: 12,
          backgroundColor: 'var(--color-bg-surface)',
          border: '1px solid var(--color-border-strong)',
          boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h4
          id="org-member-remove-title"
          style={{
            margin: '0 0 10px 0',
            fontSize: '16px',
            fontWeight: 600,
            color: 'var(--color-text)',
          }}
        >
          Remove from organization?
        </h4>
        <p style={{ margin: '0 0 16px 0', fontSize: '14px', lineHeight: 1.5 }}>
          Remove{' '}
          <strong>
            {(orgMemberRemoveTarget.display_name || '').trim() ||
              (orgMemberRemoveTarget.email || '').trim() ||
              'this member'}
          </strong>{' '}
          from{' '}
          <strong>
            {(currentOrg as Record<string, unknown>)?.display_name &&
            typeof (currentOrg as Record<string, unknown>).display_name === 'string'
              ? ((currentOrg as Record<string, unknown>).display_name as string).trim()
              : currentOrg?.name?.trim() || 'this organization'}
          </strong>
          ? They lose access to all products in this org; roster rows stay for capacity history.
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            type="button"
            className="save-button"
            style={{
              backgroundColor: 'transparent',
              color: 'var(--color-text-secondary)',
              border: '1px solid var(--color-border-strong)',
            }}
            disabled={orgMemberRemoveLoading}
            onClick={() => !orgMemberRemoveLoading && setOrgMemberRemoveTarget(null)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="save-button"
            style={{ backgroundColor: '#dc2626' }}
            disabled={orgMemberRemoveLoading}
            onClick={() => void executeRemoveOrgMember()}
          >
            {orgMemberRemoveLoading ? 'Removing\u2026' : 'Remove member'}
          </button>
        </div>
      </div>
    </div>
  );
};
